import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { useSelector, useDispatch } from "react-redux";
import { closeDrawer } from "../../../redux/filterDrawerSlice";
import { useLocation } from "react-router-dom";
import GlobalFilter from "./GlobalFilter";

const FilterDrawer = ({ children }) => {
  const dispatch = useDispatch();
  const open = useSelector((state) => state.filterDrawer?.open ?? false);
  const location = useLocation();

  useEffect(() => {
    dispatch(closeDrawer());
  }, [location.pathname, dispatch]);

  return (
    <React.Fragment>
      <GlobalFilter
        open={open}
        onClose={() => dispatch(closeDrawer())}
        title="Filter"
        tooltip="This is page level filter"
      />
      <Box
        sx={{
          marginLeft: open ? "260px" : 0,
          transition: "margin-left 0.3s ease",
        }}
      >
        {children}
      </Box>
    </React.Fragment>
  );
};

export default FilterDrawer;